import { APP_EVENT_INFO } from '@hero/constants';
import { storage } from '@hero/utils';
import { generateUUID } from '@hero/utils/generateUUID';

/**
 * Generates or retrieves the browser's UUID
 * If UUID doesn't exist in storage, generates a new one and saves it
 * @returns {string} The browser's UUID
 */
export function getBrowserUUID() {
  let browserUUID = storage.getBrowserUUID() ?? '';
  if (!browserUUID) {
    browserUUID = generateUUID();
    storage.setBrowserUUID(browserUUID);
  }

  return browserUUID;
}

/**
 * @typedef {Object} DeviceInfo
 * @property {string} appName - Name of the application
 * @property {string} userAgent - Browser user agent string
 * @property {number} height - Window height in pixels
 * @property {number} width - Window width in pixels
 */
/**
 * Gets device information including dimensions, platform, and browser details
 * @returns {DeviceInfo} Object containing device information
 */
export function getDevice() {
  const userAgent = window.navigator.userAgent;
  const { innerWidth: width, innerHeight: height } = window;

  return {
    appName: APP_EVENT_INFO.appName,
    userAgent,
    height,
    width
  };
}

/**
 * @typedef {Object} PageInfo
 * @property {string} url - Current page URL
 * @property {number} height - Page height in pixels
 * @property {number} width - Page width in pixels
 * @property {string} type - Page type identifier
 */
/**
 * @typedef {Object} PageParams
 * @property {string} page - Page type identifier
 */
/**
 * Gets current page information including dimensions and type
 * @param {PageParams} params - Parameters for page information
 * @returns {PageInfo} Object containing page information
 */
export function getPage({ page }) {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    url: window.location.href,
    height,
    width,
    type: page
  };
}
